import { render } from "./ResumeChoixSurface.vue?vue&type=template&id=1ea81556"
import script from "./ResumeChoixSurface.vue?vue&type=script&lang=js"
export * from "./ResumeChoixSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__